<div id="d-wrap" class="dot-wrapper" [ngStyle]="{ width: width, height: height, position: 'relative' }">
  <div *ngFor="let dot of dots" class="ghost-dot" [ngStyle]="{
      top: dot.top + 'px',
      left: dot.left + 'px'
    }"></div>
  <div id="q-mark" class="question-mark">?</div>
</div>